"use strict";const _jsxFileName = "/home/runner/work/bloom-mono/bloom-mono/apps/frontend/webChat/src/screens/Signup/components/BackArrow.tsx";Object.defineProperty(exports, "__esModule", {value: true}); function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }var _react = require('react'); var _react2 = _interopRequireDefault(_react);
var _reactdom = require('react-dom');

var _AuthFrame = require('web/components/AuthFrame');

/**
 * The wizard's back affordance: a chevron and "Back" beside the step's action
 * on desktop. On a phone it renders into the doodle band (a portal into the
 * frame's back slot), beside the progress, so it comes first in tab order as
 * it does on screen. Carries aria-label="Back" so existing role/name queries
 * and screen readers keep addressing it as the Back button.
 */
const BackArrow = ({ onClick, disabled }) => {
  const slot = _react.useContext.call(void 0, _AuthFrame.AuthFrameBackSlot)
  const isPhone = _AuthFrame.useIsPhoneFrame.call(void 0, )
  const button = (
    _react2.default.createElement('button', {
      type: "button",
      'aria-label': "Back",
      disabled: disabled,
      onClick: onClick,
      className: "signup-step--back-arrow", __self: this, __source: {fileName: _jsxFileName, lineNumber: 17}}

      , _react2.default.createElement('svg', {
        viewBox: "0 0 24 24"   ,
        fill: "none",
        stroke: "currentColor",
        strokeWidth: "2.2",
        strokeLinecap: "round",
        strokeLinejoin: "round",
        'aria-hidden': "true", __self: this, __source: {fileName: _jsxFileName, lineNumber: 24}}

        , _react2.default.createElement('path', { d: "M15 5l-7 7 7 7"    , __self: this, __source: {fileName: _jsxFileName, lineNumber: 33}} )
      )
      , _react2.default.createElement('span', { className: "signup-step--back-arrow--label", 'aria-hidden': "true", __self: this, __source: {fileName: _jsxFileName, lineNumber: 35}}, "Back")
    )
  )
  return isPhone && slot ? _reactdom.createPortal.call(void 0, button, slot) : button
}

exports. default = BackArrow
